<template>
   
      <HomeComponent />
    
  </template>
  
  <script>
  import HomeComponent from '@/components/HomeComponent.vue';
  
  export default {
    components: {
      HomeComponent,
    }
  }

  </script>
  